import React from 'react'
import Dinning1 from "../assets/Gallery_photo/Dinning_photo/gallery-dinning-01.jpg"
import Dinning2 from "../assets/Gallery_photo/Dinning_photo/gallery-dinning-02.jpg"
import Dinning3 from "../assets/Gallery_photo/Dinning_photo/gallery-dinning-03.jpg"
import Dinning4 from "../assets/Gallery_photo/Dinning_photo/gallery-dinning-04.jpg"
import Dinning5 from "../assets/Gallery_photo/Dinning_photo/gallery-dinning-05.jpg"
import Dinning6 from "../assets/Gallery_photo/Dinning_photo/gallery-dinning-06.jpg"
import Dinning7 from "../assets/Gallery_photo/Dinning_photo/gallery-dinning-07.jpg"
import Dinning8 from "../assets/Gallery_photo/Dinning_photo/gallery-dinning-08.jpg"
import Dinning9 from "../assets/Gallery_photo/Dinning_photo/gallery-dinning-09.jpg"
import RandomComp from '../components/PhotosComponent'

export const Dinning = () => {
  return (
    <RandomComp img1={Dinning1} img2={Dinning2} img3={Dinning3} img4={Dinning4} img5={Dinning5} img6={Dinning6} img7={Dinning7} img8={Dinning8} img9={Dinning9}></RandomComp>
  )
}
